export default {
  settings: "/settings",
  update_settings: (id) => `settings/${id}`,
};
